import React from "react";
import { AHSeparator, Box } from "arkh";
import { View } from "react-native";

export function TeamScheduleListItemWrapper(props: {
  children: React.ReactNode;
  itemType: "timeOfDay" | "WEEKLY" | "MONTHLY";
  isFirst: boolean;
  isLast: boolean;
  radius?: "medium" | "large";
  border?: boolean;
  showBorder?: boolean;
  showSeparator?: boolean;
}) {
  const radius = props.radius ?? "medium";
  return (
    <Box spaceHorizontal="medium" style={{ height: "100%" }}>
      {props.isFirst || props.showSeparator === false ? null : (
        <View style={{ zIndex: 999 }}>
          <AHSeparator />
        </View>
      )}
      <Box
        color="surface"
        cornerRadiusBottomLeft={props.isLast ? radius : "none"}
        cornerRadiusBottomRight={props.isLast ? radius : "none"}
        cornerRadiusTopRight={props.isFirst ? radius : "none"}
        cornerRadiusTopLeft={props.isFirst ? radius : "none"}
        style={{
          flexDirection: "row",
          alignItems: "center",
          flex: 1,
          borderLeftWidth: props.border ? 1 : 0,
          borderRightWidth: props.border ? 1 : 0,
          borderTopWidth: props.isFirst && props.border ? 1 : 0,
          borderBottomWidth: props.isLast && props.border ? 1 : 0,
        }}
        borderColor={props.border ? "border-primary" : "transparent"}
      >
        {props.children}
      </Box>
    </Box>
  );
}
